import { RefreshCw } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Skeleton } from '@/components/ui/skeleton';
import { Badge } from '@/components/ui/badge';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { useAdminUplogStats } from '@/hooks/useAdmin';
import { useQueryClient } from '@tanstack/react-query';

export function AdminUplogStats() {
  const qc = useQueryClient();
  const { data: stats, isLoading } = useAdminUplogStats();

  return (
    <Card>
      <CardHeader className="flex flex-row items-start justify-between space-y-0">
        <div>
          <CardTitle>Disparos UpLog — Todos os clientes</CardTitle>
          <CardDescription>Resumo de boletos e disparos WhatsApp por cliente.</CardDescription>
        </div>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => void qc.invalidateQueries({ queryKey: ['admin', 'uplog-stats'] })}
          title="Atualizar"
        >
          <RefreshCw className="h-4 w-4" />
        </Button>
      </CardHeader>
      <CardContent>
        {isLoading && (
          <div className="space-y-2">
            {[1, 2, 3].map((i) => (
              <Skeleton key={i} className="h-10 w-full" />
            ))}
          </div>
        )}

        {!isLoading && (!stats || stats.length === 0) && (
          <p className="text-sm text-muted-foreground">Nenhum cliente com módulo UpLog ativo.</p>
        )}

        {stats && stats.length > 0 && (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Cliente</TableHead>
                <TableHead className="text-right">Hoje</TableHead>
                <TableHead className="text-right">Mês</TableHead>
                <TableHead className="text-right">Falhas (mês)</TableHead>
                <TableHead className="text-right">Pendentes</TableHead>
                <TableHead className="text-right">Vencidos</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {stats.map((s) => (
                <TableRow key={s.tenantId}>
                  <TableCell className="font-medium">{s.tenantName}</TableCell>
                  <TableCell className="text-right">{s.today.toLocaleString('pt-BR')}</TableCell>
                  <TableCell className="text-right">
                    {s.thisMonth.toLocaleString('pt-BR')}
                  </TableCell>
                  <TableCell className="text-right">
                    {s.failedMonth > 0 ? (
                      <Badge variant="destructive" className="text-xs">
                        {s.failedMonth.toLocaleString('pt-BR')}
                      </Badge>
                    ) : (
                      <span className="text-muted-foreground">0</span>
                    )}
                  </TableCell>
                  <TableCell className="text-right">{s.pending.toLocaleString('pt-BR')}</TableCell>
                  <TableCell className="text-right">
                    {s.vencidos > 0 ? (
                      <Badge
                        variant="outline"
                        className="border-orange-300 text-orange-700 text-xs"
                      >
                        {s.vencidos.toLocaleString('pt-BR')}
                      </Badge>
                    ) : (
                      <span className="text-muted-foreground">0</span>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
}
